import './index.erb';
import './index.rb';
import './index.scss';
import applyCountdown from 'utils/countdown';
import styles from './index.module.scss';
import { Application, Controller } from 'utils/stimulus';
import { setNoScroll, removeNoScroll } from './utils';

const CARD_TYPES = {
  ANSWERS: 'answers',
  LESSONS: 'lessons',
  COMMENTS: 'comments'
};

const AnalyticsCardTypes = {
  answers: 'Respostas',
  lessons: 'Cursos',
  comments: 'Comentários'
};

export default class FreemiumLimitBottomBar extends Controller {
  constructor() {
    super();
    this.sentAnalytics = false;
    this.$freemiumLimitBottomBar = $('#freemium-limit-bottom-bar');
    this.$collapsedContainerButtons = $(
      '.js-collapsed-container-buttons',
      this.$freemiumLimitBottomBar
    );
    this.$uncollapsedContainerButtons = $(
      '.js-uncollapsed-container-buttons',
      this.$freemiumLimitBottomBar
    );
  }

  _sendAnalyticsEvent(eventName, data = {}) {
    UserTracker.emit('event', {
      eventName: eventName,
      data: data
    });
  }

  highlightComments() {
    const $commentsTab = $('[data-component-name="question_comments"]');
    $commentsTab.find('.cta-pulse').removeClass('hidden');
  }

  runCountdownBottomBar(cardType) {
    applyCountdown({
      selector: `#freemium-limit-bottom-bar .card-limit-countdown-${cardType}`,
      template: '%H:%M:%S'
    });
  }

  async getResourcesSummary() {
    try {
      const { summary } = await Thor.User.used_resources_summary(
        { user_id: currentUser.id },
        {}
      );
      const resources = summary.resources;
      return resources;
    } catch (error) {
      Rollbar.error('Error on getResourcesSummary', error);
    }
  }

  handleCollapsableButton() {
    if (this.$freemiumLimitBottomBar.hasClass('opened')) {
      this.$freemiumLimitBottomBar.removeClass('opened');
      removeNoScroll();
    } else {
      this.$freemiumLimitBottomBar.addClass('opened');
      setNoScroll();

      if (!this.sentAnalytics) {
        this._sendAnalyticsEvent('study suggestion viewed', {
          component_study_suggestion: 'Bottombar após limite de 10 questões',
          request_path: window.location.pathname
        });
        this.sentAnalytics = true;
      }
    }
  }

  handleExitButton() {
    this.setClosedBottomBar();
    removeNoScroll();
    this.$freemiumLimitBottomBar.addClass('hidden');
  }

  setClosedBottomBar() {
    this.$freemiumLimitBottomBar.hasClass('opened') &&
      this.$freemiumLimitBottomBar.removeClass('opened');
  }

  anyHasLimit(resources) {
    const { answers, comments, lessons } = resources;
    const selectedResources = { answers, comments, lessons };
    return Object.values(selectedResources).some(
      resource => resource.remaining > 0
    );
  }

  answersLimitReached(resources) {
    return !resources.answers.remaining;
  }

  changeHtmlWithoutLimit(resources) {
    if (this.anyHasLimit(resources)) {
      return;
    }

    $('#bottom-bar-closed-info')
      .find('h4 span')
      .html(', continue estudando de graça, <strong>em breve!</strong>');

    $('.content-bar')
      .find('#subtitle')
      .text(
        'Você terá acesso aos seus recursos novamente ao fim do contador, ou estude sem limites assinando nosso plano! '
      );
  }

  showCountdown(resources) {
    const self = this;
    $('.card-wrapper').each(function () {
      const cardType = $(this).data('card-type');
      const limitReached = resources[cardType].remaining === 0;

      if (!limitReached) {
        return;
      }

      $(this).addClass(`${styles['limit-reached']}`);

      $(this)
        .find(`.${styles['card-countdown']}`)
        .toggleClass('hidden', !limitReached);

      self.runCountdownBottomBar(cardType);
    });
  }

  OpenBottomBarEventScroll() {
    const self = this;
    const firstScrollDone = false;

    window.addEventListener(
      'scroll',
      function () {
        if (
          firstScrollDone ||
          self.$freemiumLimitBottomBar.hasClass('hidden')
        ) {
          return;
        }
        self.handleCollapsableButton();

        this.firstScrollDone = true;
      },
      { once: true }
    );
  }

  handleCardClick(event) {
    event.preventDefault();
    const cardType = $(event.currentTarget).data('card-type');
    const limitReached = $(event.currentTarget).hasClass(
      `${styles['limit-reached']}`
    );

    if (cardType === CARD_TYPES.ANSWERS || limitReached) {
      return;
    }

    this._sendAnalyticsEvent('study suggestion interest', {
      component_study_suggestion: 'Bottombar após limite de 10 questões',
      selected_study_suggestion: AnalyticsCardTypes[cardType],
      request_path: window.location.pathname
    });

    if (cardType === CARD_TYPES.LESSONS) {
      window.location.href = $(event.currentTarget).data('redirect-url');
    } else if (cardType === CARD_TYPES.COMMENTS) {
      this.highlightComments();
      this.handleCollapsableButton();
    } else {
      this.handleCollapsableButton();
    }
  }

  async load() {
    const resources = await this.getResourcesSummary();
    const answersLimitReached = this.answersLimitReached(resources);

    if (!answersLimitReached) {
      return;
    }

    this.setClosedBottomBar();
    this.showCountdown(resources);
    this.changeHtmlWithoutLimit(resources);

    this.$freemiumLimitBottomBar.removeClass('hidden');
  }
}

global.FreemiumLimitBottomBarApplication =
  global.FreemiumLimitBottomBarApplication || Application.start();
global.FreemiumLimitBottomBarApplication.register(
  'freemium-limit-bottom-bar-events',
  FreemiumLimitBottomBar
);
